module.exports = __webpack_public_path__ + "static/sugargator-92aecc5c206e8d6d5ed29a06cfdf870a.png";